import React, { useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router";

import clsx from "clsx";
import { Dispatch, bindActionCreators } from "redux";

import { Overlay, BannerStatus, DefaultActionSection } from "@plex/react-components";

import { INotification } from "infrastructure/notification";
import { Banner } from "ui/app";
import { useUserContext } from "ui/hooks";
import commonStyles from "ui/screens/translation-managers/shared/styles/Translations.module.scss";

import { PlexTranslationMessagesManagerActionBar } from "./actionBar";
import { PlexTranslationMessagesManagerFilter } from "./filter";
import { PlexTranslationMessagesManagerGrid } from "./grid";
import { plexTranslationMessagesActions } from "./PlexTranslationMessages.actions";
import styles from "./PlexTranslationMessages.module.scss";
import { IPlexTranslationMessagesManagerState } from "./PlexTranslationMessages.state";

interface IPlexTranslationMessagesManagerProps {
  isLoading: boolean;
  notifications: INotification[];
  initialize: () => void;
  savePlexTranslations: () => void;
}

const PlexTranslationMessagesManager: React.FC<IPlexTranslationMessagesManagerProps & RouteComponentProps> = ({ isLoading, notifications, initialize, savePlexTranslations }) => {
  useEffect(() => {
    initialize();
  }, [initialize]);

  const userContext = useUserContext();
  const roles = userContext.getRoleAccessData();

  const savePlexTranslationsExecute = useCallback(() => {
    savePlexTranslations();
  }, [savePlexTranslations]);

  const bannerScroll = useCallback((message: INotification) => {
    return message.type === BannerStatus.error;
  }, []);

  return (
    <div className={clsx(styles.base, { [commonStyles.withActionSection]: roles.LocalizationManager || roles.PlexLocalizationManager })}>
      <Overlay show={isLoading} showSpinner />
      <Banner shouldScroll={bannerScroll} messages={notifications} />
      <PlexTranslationMessagesManagerFilter />
      <PlexTranslationMessagesManagerActionBar />
      <PlexTranslationMessagesManagerGrid />
      {(roles.LocalizationManager || roles.PlexLocalizationManager) && <DefaultActionSection onApply={savePlexTranslationsExecute} />}
    </div>
  );
};

export default connect(
  (state: { plexTranslationMessagesManager: IPlexTranslationMessagesManagerState }) => {
    return {
      isLoading: state.plexTranslationMessagesManager.isLoading,
      notifications: state.plexTranslationMessagesManager.notifications
    };
  },
  (dispatch: Dispatch) => {
    return bindActionCreators(
      {
        savePlexTranslations: plexTranslationMessagesActions.savePlexTranslations,
        initialize: plexTranslationMessagesActions.initialize
      },
      dispatch
    );
  }
)(PlexTranslationMessagesManager);
